<template>
  <!-- 好友列表 -->
  <div class="m-list">
    <footer>
      <el-input
        class="search"
        placeholder="搜索"
        prefix-icon="el-icon-search"
        v-model="search.text"
      ></el-input>
    </footer>
    <ul style="height: calc(100% - 65px);overflow: auto;border-bottom: 1px solid #999;">
      <li
        id="badgestyle"
        v-for="(item, index) in userList.filter(
          (x) => x.name.indexOf(search.text) > -1
        )"
        :class="{ active: choose ? session.userId === item.id : false }"
        @click="select(item)"
        :key="index"
      >
        <el-badge :value="item.unRead" :hidden="item.unRead == 0">
          <img
            class="avatars"
            width="30"
            height="30"
            alt="加载失败"
            :src="item.img"
          />
        </el-badge>
        <div class="friendmsg" :key="test">
          <p class="name">
            <span>{{ item.name }}</span>
            <span
              style="font-size: 12px"
              v-if="item.historyMsg || item.showlasttime"
            >
              {{ item | time }}
            </span>
          </p>
          <span
            id="imgW"
            v-if="item.historyMsg || item.showlasttext"
            v-html="
              item.showlasttext
                ? item.showlasttext
                : item.historyMsg.chattype == 0
                ? item.historyMsg.chatcontent
                : item.historyMsg.chattype == 1
                ? '[图片]'
                : item.historyMsg.chattype == 2
                ? '[文件]'
                : item.historyMsg.chattype == 3
                ? '[语音]'
                : ''
            "
          ></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from "@/http/axios";
let vm = {};
export default {
  props: ["userList", "sessionIndex", "session", "search", "choose"],
  data() {
    vm = this;
    return {
      test: 0,
      showlasttext: "",
      showlasttime: "",
      pageSize: 10,
    };
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time(item) {
      let time = null;
      if (item.showlasttime) {
        time = vm.$tu.isToday(item.showlasttime)
          ? new Date(new Date(item.showlasttime).getTime()).format("hh:mm")
          : new Date(new Date(item.showlasttime).getTime()).format("yy/M/d");
      } else {
        time = vm.$tu.isToday(item.historyMsg.createTime)
          ? new Date(new Date(item.historyMsg.createTime).getTime()).format(
              "hh:mm"
            )
          : new Date(new Date(item.historyMsg.createTime).getTime()).format(
              "yy/M/d"
            );
      }
      return time;
    },
  },
  watch: {
    "session.messages": {
      deep: true,
      handler(val) {
        if (val && val.length > 0) {
          if (val[val.length - 1].type == 1) {
            // 截图显示[图片]
            this.userList.filter(
              (x) => x.conversationid == this.session.conversationid
            )[0].showlasttext = "[图片]";
          } else if (val[val.length - 1].type == 2) {
            // 文件
            this.userList.filter(
              (x) => x.conversationid == this.session.conversationid
            )[0].showlasttext = "[文件]";
          } else if(val[val.length - 1].type == 0) {
            this.userList.filter(
              (x) => x.conversationid == this.session.conversationid
            )[0].showlasttext = val[val.length - 1].text;
          }else if(val[val.length - 1].type == 3){
            this.userList.filter(
              (x) => x.conversationid == this.session.conversationid
            )[0].showlasttext = "[语音]";
          }
          this.userList.filter(
            (x) => x.conversationid == this.session.conversationid
          )[0].showlasttime = val.length > 0 ? val[val.length - 1].date : "";
          this.test++;
        }
      },
    },
  },
  methods: {
    // 选中好友
    select(value) {
      value.unRead = 0;
      this.$emit("emptyShow");
      this.sessionIndex.index = this.userList.indexOf(value);
      this.sessionIndex.id = this.userList.filter(
        (x) => x.id == value.id
      )[0].id;

      /**
       *张俊娜：2019/12/26
       *描述：改变未读状态
       *版本：1.0
       */
      axios({
        hostUrl: this.zuul,
        url:
          "/xyj-im/r/imChatHistory/readMessage?fromchatid=" +
          sessionStorage.getItem('chatid') +
          "&tochatid=" +
          value.conversationid +
          "&topic=" +
          this.$topic.$IMNEWS,
        method: "get",
      })
        .then((res) => {
          if (res.code == 200) {
						this.$emit('isRead')
            this.getHistory(value);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 获取历史消息
    getHistory(data) {
      let params =
        "?page=1&pageSize=" +
        this.pageSize +
        "&tochatid=" +
        data.conversationid +
        "&fromchatid=" +
        sessionStorage.getItem('chatid');
      axios({
        hostUrl: this.zuul,
        url: "/xyj-im/r/imChatHistory/findChatHistory" + params,
        method: "get",
      })
        .then((res) => {
          let id = "";
          if (this.session && this.session.userId) {
            id = this.userList.filter(
              (item) => item.id === this.session.userId
            )[0].conversationid;
          }
          this.session.messages = res.data.rows
            .map((x) => {
              let obj = {};
              obj.text = x.chatcontent;
              obj.date = x.createTime;
              obj.self = x.fromchatid == id ? false : true;
              obj.alreadyread = x.alreadyread;
              obj.type = x.chattype;
              obj.id = x.id;
              if (
                x.chatcontent.toString().indexOf("img") > -1 &&
                !(x.chatcontent.toString().indexOf("pasteImg") > -1)
              ) {
                let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
                let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
                let str = x.chatcontent;
                let arr = str.match(imgReg); //筛选出所有的img
                if (arr) {
                  for (let i = 0; i < arr.length; i++) {
                    let src = arr[i].match(srcReg);
                    // 获取图片地址
                    obj.imgurl = src[1];
                  }
                }
              }
              if (x.chatcontent.toString().indexOf("msg") > -1) {
                  obj.type = 2
                  obj.text = JSON.parse(x.chatcontent).msg
                  obj.fileUrl = JSON.parse(x.chatcontent).fileurl
                  obj.date = new Date()
                  obj.imgurl = ""
              }
              return obj;
            })
            .reverse();
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-list {
  background-color: #eee!important;
}
ul {
  margin: 0 !important;
  padding: 0 !important;
}
li {
  display: flex;
  padding: 12px 15px;
  /*border-bottom: 1px solid #292c33;*/
  cursor: pointer;
  transition: background-color 0.1s;
  list-style: none;
  &:hover {
    background-color: rgba(88, 88, 88, 0.03);
  }
}
.active {
  background-color: #cac8c6;
}
.avatars,
.name {
  vertical-align: middle;
}
.avatars {
  border-radius: 2px;
}
.name {
  width: 135px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 0 15px;
}
footer {
  padding: 15.5px 12px;
  border-bottom: 1px solid #ccc;
}
.search /deep/ input {
  width: 100%;
  font-size: 12px;
  color: #000;
  height: 30px;
  line-height: 30px;
  border: solid 1px #dbd9d8;
  border-radius: 4px;
  outline: none;
  background-color: #dbd9d8;
  box-sizing: border-box;
}
.search /deep/ .el-input__prefix > .el-input__icon {
  line-height: 30px;
}
.circleStyle {
  position: relative;
}
.circleStyle > i {
  position: absolute;
  right: -3px;
  top: -3px;
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
}
.friendmsg {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 150px;
}
.friendmsg > span {
  margin-left: 15px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#imgW {
  color: #999;
}
#imgW >>> .pasteImg {
  width: 20px;
  height: 20px;
  vertical-align: sub;
}
#badgestyle /deep/ .el-badge__content {
  top: 0 !important;
  right: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/vueChart/list.vue